import React from "react";
import { Button } from "antd";
import { Icon } from "@iconify/react";
import "./layouts-styles.css";

/**
 * Error state.
 *
 * Says what went wrong and how to fix it, in the interface's voice — no
 * apology, no raw exception text, and always a way forward.
 */
const BaseError = ({
  title = "This didn't load",
  description = "The server didn't answer. Check your connection and try again.",
  onRetry,
  retryLabel = "Try again",
}) => (
  <div className="state-block is-error">
    <span className="state-mark">
      <Icon icon="tabler:plug-connected-x" width={ 28 } />
    </span>
    <span className="state-title">{ title }</span>
    <p className="state-desc">{ description }</p>
    { onRetry &&
      <div className="state-action">
        <Button onClick={ onRetry }>{ retryLabel }</Button>
      </div> }
  </div>
);

export default BaseError;
